/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chartperiodall2Inputs */

const en_chartperiodall2 = /** @type {(inputs: Chartperiodall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const de_chartperiodall2 = /** @type {(inputs: Chartperiodall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Chartperiodall2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const chartperiodall2 = /** @type {((inputs?: Chartperiodall2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chartperiodall2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chartperiodall2(inputs)
	return de_chartperiodall2(inputs)
});
export { chartperiodall2 as "chartPeriodAll" }